import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { ReferToneRequest } from './refertonerequest';
import { POST } from '../../api';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class ReferToneAPI extends SixdeeCRBTAPI<ReferToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/referral
        return "referral";
    }

    getRequestData()
    {
        // let msisdnList = '{"msisdn":"' +  this.getRequest().getReferToneRequest().getMsisdnList()[0] + '"' +
        // ',"customerContent":"customerContent_temp"' + 
        // ',"packName":"'+this.getRequest().getReferToneRequest().getPackName() + '"' +
        // ',"languageId":"'+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2") + '"' +
        // ',"toneId":"' +this.getRequest().getReferToneRequest().getToneId() + '"},' + 
        // '{"msisdn":"' +  this.getRequest().getReferToneRequest().getMsisdnList()[1] + '"' +
        // ',"customerContent":"customerContent_temp"' + 
        // ',"packName":"'+this.getRequest().getReferToneRequest().getPackName() + '"' +
        // ',"languageId":"'+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2") + '"' +
        // ',"toneId":"' +this.getRequest().getReferToneRequest().getToneId() + '"},' +
        // '{"msisdn":"' +  this.getRequest().getReferToneRequest().getMsisdnList()[2] + '"' +
        // ',"customerContent":"customerContent_temp"' + 
        // ',"languageId":"'+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2") + '"' +
        // ',"packName":"'+this.getRequest().getReferToneRequest().getPackName() + '"' +
        // ',"toneId":"' +this.getRequest().getReferToneRequest().getToneId() + '"}';
        let msisdnList = '{"msisdn":"' +  this.getRequest().getReferToneRequest().getMsisdnList()[0] + '"' +
        ',"customerContent":"customerContent_temp"' + 
        ',"packName":"'+this.getRequest().getReferToneRequest().getPackName() + '"' +
        ',"languageId":"'+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2") + '"' +
        ',"toneId":"' +this.getRequest().getReferToneRequest().getToneId() + '"}'; 
        // '{"msisdn":"' +  this.getRequest().getReferToneRequest().getMsisdnList()[1] + '"' +
        // ',"customerContent":"customerContent_temp"' + 
        // ',"packName":"'+this.getRequest().getReferToneRequest().getPackName() + '"' +
        // ',"languageId":"'+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2") + '"' +
        // ',"toneId":"' +this.getRequest().getReferToneRequest().getToneId() + '"},' +
        // '{"msisdn":"' +  this.getRequest().getReferToneRequest().getMsisdnList()[2] + '"' +
        // ',"customerContent":"customerContent_temp"' + 
        // ',"languageId":"'+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2") + '"' +
        // ',"packName":"'+this.getRequest().getReferToneRequest().getPackName() + '"' +
        // ',"toneId":"' +this.getRequest().getReferToneRequest().getToneId() + '"}';
        
        return "aPartyMsisdn="+ this.getRequest().getReferToneRequest().getAPartyMsisdn()+"&"+
               "toneId="+ this.getRequest().getReferToneRequest().getToneId()+"&"+
               "toneName="+ this.getRequest().getReferToneRequest().getToneName()+"&"+
               "packName="+ this.getRequest().getReferToneRequest().getPackName()+"&"+
               "language="+ (this.getRequest().getReferToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")
               +"&"+
               "msisdnList="+ "[" + msisdnList + "]";
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/refertone/refertoneapi.tsx